import { environment } from '../../../../../environments/environment';
import {
    Component,
    EventEmitter,
    Input,
    OnInit,
    Output,
    SimpleChanges,
    OnChanges
} from '@angular/core';
import { Validators } from '@angular/forms';
import {
    Reply,
    ReplyCreationParams,
    ReplyDeleteData,
    ReplyUpdateData,
} from '../../../models/commments.model';
import { User } from '../../../models';
import * as fromLinkFileList from '../../../../reducers/link-file-list.reducer';

@Component({
    selector: 'app-reply',
    templateUrl: './reply.component.html',
    styleUrls: ['./reply.component.scss', '../comment/comment.component.scss']
})
export class ReplyComponent implements OnInit, OnChanges {
    @Input() isInputBox: boolean; // true if this component is for new reply input
    @Input() user: User | undefined;
    @Input() reply: Reply | undefined;
    @Input() commentID: string;
    @Input() ownerId: number;
    @Input() tempSession: string; //base64 string represents a session token for anonymous user, empty if authenticated
    @Input() link: fromLinkFileList.State;
    @Output() replyCreationEvent = new EventEmitter<ReplyCreationParams>();
    @Output() replyEditionEvent = new EventEmitter<ReplyUpdateData>();
    @Output() replyDeletionEvent = new EventEmitter<ReplyDeleteData>();
    @Output() toggleReplyInputBoxEvent = new EventEmitter();

    newReply: string = '';
    replyEdition: string = '';
    authorAvatar: string; // comment author avatar
    avatarEndpoint = `${environment.logohost}avatar/saved`;
    confirmedDelete: boolean;
    editMode: boolean;
    buttonPrimaryColor: string;
    buttonTextColor: string;
    contentLength = 200;

    constructor() {}

    ngOnInit() {
        if (this.isInputBox) {
            this.newReply = '';
        }
        if (this.reply) {
            this.replyEdition = this.reply.content;
        } else {
            this.replyEdition = '';
        }

        if (this.reply && !this.reply.temp_session) {
            this.authorAvatar = `${this.avatarEndpoint}/${this.reply.author_id}`;
        }

        if (this.link.image_cachekey) {
            this.buttonPrimaryColor = this.link.button_primary_color;
            this.buttonTextColor = this.link.button_text_color;
        }
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.user) {
            this.user = changes.user.currentValue;
        }

        if (changes.tempSession) {
            this.tempSession = changes.tempSession.currentValue;
        }

        if (changes.link) {
            this.link = changes.link.currentValue;
        }
    }

    createReply = () => {
        let newReply: ReplyCreationParams;
        newReply = {
            parent_id: this.commentID,
            author_id: this.user.id,
            author_name: this.user.display_name,
            content: this.newReply,
            temp_session: this.tempSession,
        };
        this.replyCreationEvent.emit(newReply);
        this.newReply = '';
    }

    editReply = () => {
        this.toggleEditMode();
    }

    updateReply = () => {
        let data: ReplyUpdateData;
        data = {
            parent_id: this.reply.parent_id,
            reply_id: this.reply.reply_id,
            author_id: this.user.id,
            content: this.replyEdition,
            temp_session: this.tempSession,
        };

        this.replyEditionEvent.emit(data);
        this.editMode = false;
        this.replyEdition = '';
    }

    deleteReply = () => {
        let data: ReplyDeleteData;
        data = {
            parent_id: this.reply.parent_id,
            reply_id: this.reply.reply_id,
            author_id: this.user.id,
            temp_session: this.tempSession,
        };

        this.replyDeletionEvent.emit(data);
    }

    toggleEditMode = () => {
        this.editMode = !this.editMode;
    }

    toggleReplyInputBox = () => {
        this.toggleReplyInputBoxEvent.emit();
    }

    toggleConfirm = () => {
        this.confirmedDelete = !this.confirmedDelete;
    }

    cancelEditMode = () => {
        this.editMode = false;
        this.replyEdition = this.reply.content;
    }

    cancelReplyCreation = () => {
        this.newReply = '';
    }

    cancelConfirm = () => {
        this.confirmedDelete = false;
    }

    validContent(value: string | undefined) {
        return value != undefined && value.trim().length !== 0;
    }

}
